// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AccountService } from '../../../../../../../src/app/core/_base/layout/services/account.service';
import { AccountManagementModel } from '../../../../../../../src/app/views/pages/master/account-management/model/account-managementList.model';

@Component({
	selector: 'kt-refund-entity-dialog',
	templateUrl: './refund-entity-dialog.component.html'
})
export class RefundEntityDialogComponent implements OnInit {
	// Public properties
	invalid: boolean = false;
	maxamount: number;
	viewLoading: boolean = false;
	accountModel = new AccountManagementModel();
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<RefundEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		public accountService: AccountService,
		public dialogRef: MatDialogRef<RefundEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.maxamount = this.accountService.ammount$.getValue();		
		this.accountModel.amount = this.data.amount;						
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}
	isNumber(o): boolean {
		return ! isNaN (o-0) && o !== null && o !== "" && o !== false;
	}
	checkvalue(value,amount) {
		this.invalid = false;		
		if (value.target.value == '') {
			this.invalid = false;
		} else if (amount == 0) {
			this.invalid = true;
		}
	}
	/**
	 * Close dialog with true result
	 */
	onYesClick(refundForm, ammount): void {
		this.invalid = false;		
		if (refundForm.form.valid && ammount == 'true') {
			this.accountService.loadAmmount(this.accountModel.amount);
			/* Server loading imitation. Remove this */
			this.viewLoading = true;
			setTimeout(() => {
				this.dialogRef.close(true); // Keep only this row
			}, 2500);
		} else {			
			this.viewLoading = false;
			if (ammount == 'false') {
				this.invalid = true;
			} else {
				this.invalid = false;
			}
		}
	}
}
